import styled from "styled-components";

export const FilterItemRow = styled.div`
    display: flex;
    flex-wrap: nowrap;
    cursor: pointer;
    padding-left: 8px;
    padding-top: 2px;
    
    font-family: ${(props) => props.theme.text.regular};
    font-size: ${(props) => props.theme.fontSizeExtraLarge};
    
    &.active {
        background: ${(props) => props.theme.colors["paz-black-l-97"]};
    }

    &:hover {
        background: ${(props) => props.theme.colors["paz-black-l-97"]};
        .include {
            color: ${(props) => props.theme.colors["green-leaf"]};
        }
    }
    
    .include, .exclude {
        padding: 0 5px;
        height: 24px;
        width: 24px;
        color: ${(props) => props.theme.colors["gray-light"]};
        cursor: pointer;
    }
    
    .selectedInclude.include {
        color: ${(props) => props.theme.colors["green-leaf"]};
    }
    
    .selectedExclude.exclude {
        color: ${(props) => props.theme.colors.jason};
    }
    
    .exclude:hover {
        color: ${(props) => props.theme.colors.jason};
    }

    .include:hover {
        color: ${(props) => props.theme.colors["green-leaf"]};
    }

    &.omitIsDefault:hover {
        .include {
            color: ${(props) => props.theme.colors["gray-light"]};
        }
        .exclude {
            color: ${(props) => props.theme.colors.jason};
        }
    }
    
    &.hover-minus:hover {
        .include {
            color: ${(props) => props.theme.colors["gray-light"]};
        }
    }
    
    &.omitIsDefault.hover-plus:hover {
        .include {
            color: ${(props) => props.theme.colors["green-leaf"]};
        }
        .exclude {
            color: ${(props) => props.theme.colors["gray-light"]};
        }
    }
    
    .row-label {
        width: 190px;
        min-width: 190px;
        text-overflow: ellipsis;
        display: flex;
        flex-wrap: nowrap;
        flex-grow: 1;

        .item-value, .item-category {
            padding: 1px 5px 0 5px;
        }

        .item-value {
            cursor: pointer;
            white-space: nowrap;
            color: ${(props) => props.theme.colors["gray-dark"]};

            span {
                padding: 5px;
            }

            span.more {
                font-family: ${(props) => props.theme.text.regular};
                font-size: ${(props) => props.theme.fontSizeExtraLarge};
            }
        }
        .item-category {
            color: ${(props) => props.theme.colors["gray-new"]};
        }
    }
    
    .angle {
        cursor: pointer;
        text-align: right;
        flex-grow: 0;
        min-width: 60px;
        padding-top: 3px;
        padding-right: 5px;
        color: ${(props) => props.theme.colors["gray-light"]};
    }
`;
